<template>
  <div>
    <div id="nav">
      <div class="nav-styles">
        <b-navbar toggleable type="light" variant="light">
          <b-navbar-brand
            ><router-link to="/start"
              >Oliver Borner</router-link
            ></b-navbar-brand
          >

          <b-navbar-toggle target="navbar-toggle-collapse">
            <template v-slot:default="{ expanded }">
              <b-icon v-if="expanded" icon="x"></b-icon>
              <b-icon v-else icon="list"></b-icon>
            </template>
          </b-navbar-toggle>

          <b-collapse id="navbar-toggle-collapse" is-nav>
            <b-navbar-nav
              class="navbar-nav mr-auto flex-wrap flex-row mt-4 mb-4"
            >
              <ul class="col-xs-4">
                <b-nav-item
                  ><router-link to="/installation"
                    >Installation</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/paintings"
                    >Paintings</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/paperworks"
                    >Works on Paper</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/music">Music</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/video">Video</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/tattoo">Tattoo</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/writing">Writing</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/fashion">Fashion</router-link></b-nav-item
                >
              </ul>

              <ul class="col-xs-4 mx-md-5 pl-5">
                <b-nav-item
                  ><router-link to="/about">About</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/news">News</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/texts"
                    >Text & Press</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/shop">Shop</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/links"
                    >Links & Blogs</router-link
                  ></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/contact">Contact</router-link></b-nav-item
                >
                <b-nav-item
                  ><router-link to="/imprint">Imprint</router-link></b-nav-item
                >
              </ul>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>
